import { render, staticRenderFns } from "./PublishArticle.vue?vue&type=template&id=71a230e3&scoped=true"
import script from "./PublishArticle.vue?vue&type=script&lang=js"
export * from "./PublishArticle.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PublishArticle.vue?vue&type=style&index=1&id=71a230e3&prod&lang=css"
import style2 from "./PublishArticle.vue?vue&type=style&index=2&id=71a230e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a230e3",
  null
  
)

export default component.exports